export const campfireLimit = 5;
